<div class="h-full w-full bg-white">
  @if (isEnterpriseOrTrustRoute) {
    <!-- SOC 2 Banner for Enterprise Route -->
    <div class="bg-background-neutral-1 p-4 text-center text-base">
      <span>🔒</span>&nbsp;
      <!-- Mobile text -->
      <span class="md:hidden">
        We are now <strong>SOC 2 Type II certified!</strong>&nbsp;
        <a
          class="text-black"
          href="https://capawesome.io/blog/capawesome-cloud-soc-2-type-2-compliance/"
          target="_blank"
          ><u>Learn more</u></a
        >
      </span>
      <!-- Desktop text -->
      <span class="hidden md:inline">
        <strong>Capawesome Cloud is now SOC 2 Type II certified!</strong>
        Enterprise-grade security and compliance for your apps.
        <a
          class="text-black"
          href="https://capawesome.io/blog/capawesome-cloud-soc-2-type-2-compliance/"
          target="_blank"
          ><u>Learn more</u></a
        >
      </span>
    </div>
  } @else if (isCompareRoute) {
    <!-- OpenForge Banner for Compare Routes -->
    <div class="bg-background-neutral-1 p-4 text-center text-base">
      <span>⭐</span>&nbsp;
      <!-- Mobile text -->
      <span class="md:hidden">
        Ionic Platinum Partner officially recommends Capawesome Cloud.
        <a
          class="text-black"
          href="https://openforge.io/capawesome-partner-live-updates/"
          target="_blank"
          ><u>Learn more</u></a
        >
      </span>
      <!-- Desktop text -->
      <span class="hidden md:inline">
        <strong>Officially recommended</strong> by OpenForge, an Ionic Platinum
        Partner, as the platform of choice for Capacitor apps.
        <a
          class="text-black"
          href="https://openforge.io/capawesome-partner-live-updates/"
          target="_blank"
          ><u>Learn more</u></a
        >
      </span>
    </div>
  } @else if (isNativeBuildsRoute) {
    <!-- Default Banner for other routes -->
    <div
      class="discount-promo-element bg-background-neutral-1 p-4 text-center text-base"
    >
      <span>🚀</span>&nbsp;
      <!-- Mobile text -->
      <span class="md:hidden">
        <strong>Native Builds</strong> now supports macOS Tahoe with Xcode 26.2!
        <a class="text-black" [href]="consoleBaseUrl" target="_blank"
          ><u>Get started</u></a
        >
      </span>
      <!-- Desktop text -->
      <span class="hidden md:inline">
        <strong>Native Builds</strong> now supports
        <strong>macOS Tahoe runner with Xcode 26.2</strong>! Build your apps
        with the latest tooling.
        <a class="text-black" [href]="consoleBaseUrl" target="_blank"
          ><u>Get started</u></a
        >
      </span>
    </div>
  } @else {
    <!-- Default Banner for other routes -->
    <div
      class="discount-promo-element bg-background-neutral-1 p-4 text-center text-base"
    >
      <span>⚡</span>&nbsp;
      <!-- Mobile text -->
      <span class="md:hidden">
        <strong>Live Updates</strong> ready for Capacitor 8!
        <a class="text-black" [href]="consoleBaseUrl" target="_blank"
          ><u>Start for free</u></a
        >
      </span>
      <!-- Desktop text -->
      <span class="hidden md:inline">
        <strong>Live Updates</strong> is now ready for
        <strong>Capacitor 8</strong>! Deploy updates instantly to your apps.
        <a class="text-black" [href]="consoleBaseUrl" target="_blank"
          ><u>Start for free</u></a
        >
      </span>
    </div>
  }
  <div class="m-auto h-full w-full max-w-[1280px]">
    <!-- Header -->
    <app-header></app-header>
    <!-- Main -->
    <main>
      <router-outlet></router-outlet>
    </main>
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
</div>
